module.exports = __webpack_public_path__ + "img/pvc_360g_farbauswahl_lichtgrau_anthrazit.93893a3c.jpg";